import React from "react";
import { Input } from "@/components/ui/input";
import { Section, Field, SelectField } from "@/components/assessment/FormPrimitives";
import {
  ACCOUNT_AGES, MESSAGE_QUALITIES, YES_NO_UNKNOWN,
} from "@/lib/risk";

export const GuestSignalsSection = ({ form, set, setNum }) => (
  <Section title="Guest signals" desc="Booking-level signals only — no identity, no history.">
    <Field label="Number of guest reviews">
      <Input type="number" min={0} value={form.num_reviews} onChange={setNum("num_reviews")} data-testid="field-num-reviews" />
    </Field>
    <Field label="Average guest rating (0–5)">
      <Input type="number" min={0} max={5} step={0.1} value={form.avg_rating} onChange={setNum("avg_rating")} data-testid="field-avg-rating" />
    </Field>
    <Field label="Account age">
      <SelectField value={form.account_age} onChange={set("account_age")} options={ACCOUNT_AGES} testid="field-account-age" />
    </Field>
    <Field label="Local guest">
      <SelectField value={form.local_guest} onChange={set("local_guest")} options={YES_NO_UNKNOWN} testid="field-local-guest" />
    </Field>
    <Field label="Message quality">
      <SelectField value={form.message_quality} onChange={set("message_quality")} options={MESSAGE_QUALITIES} testid="field-message-quality" />
    </Field>
    <Field label="ID verified">
      <SelectField value={form.id_verified} onChange={set("id_verified")} options={YES_NO_UNKNOWN} testid="field-id-verified" />
    </Field>
    <Field label="Security deposit available">
      <SelectField value={form.security_deposit} onChange={set("security_deposit")} options={YES_NO_UNKNOWN} testid="field-security-deposit" />
    </Field>
  </Section>
);
